module.exports = __webpack_public_path__ + "static/media/haimian-zhengrongfuhuayuan.5c916c76.jpg";